let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bSOF1")).then(() => parcelRequire('aRZbX'));